import { SubstrateSearchResponse } from '../schema/SubstrateSearchResponse';
import { SubstrateSearchSuggestionsResponse } from '../schema/SubstrateSearchSuggestionsResponse';

export type SearchResponse = SubstrateSearchResponse | SubstrateSearchSuggestionsResponse;

export const doesSubstrateResponseHasError = (response: SearchResponse) =>
    doesSubstrateResponseHasNetworkError(response) || doesSubstrateResponseHasServerError(response);

export const doesSubstrateResponseHasNetworkError = (response: SearchResponse): boolean =>
    !response;

export const doesSubstrateResponseHasServerError = (response: SearchResponse): boolean =>
    !!response?.error;
